import React, { Component } from 'react';
import './ConfirmData.css';
import logoblue from '../../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import rightlg from '../../../image/rightlg.png'
import Footer from '../Components/Footer/Footer'

class ConfirmData extends Component {

    render() {
        document.title ="kayn | تاكيد البريد الاكتروني  ";
        document.getElementsByTagName("META")[1].content="كاين | تاكيد البريد الاكتروني     ";
        document.documentElement.lang = 'ar';
        return (
            <div className="AppAR ConfirmData">
                <Navbar />
                <div className='container'>
                            <div class="mx-auto col-6 text-center alert alert-danger" role="alert">
                                <p className="fontsize6  m-0">تم إيقاف هذه الخدمة لمواصلة الوصول إلى صفحات استخدم هذا الحساب</p>
                                <p className="fontsize6  m-0">E-mail:user@user.com</p>
                                <p className="fontsize6 m-0">password:123456789</p>
                                <p className="fontsize6  m-0">لتسجيل الدخول كمسؤول <Link to="/admin/Signin">انقر هنا</Link></p>
                                <p className="fontsize6  m-0">لتسجيل الدخول كعميل <Link to="/admin/Signin">انقر هنا</Link></p>
                            </div>
                    <div className="Sign  row">
                        <div className="col-md-6 form text-center p-lg-5  ">
                        <div className=" mx-auto  textconfirm">
                            
                        <img className="mt-2 warningimg" src={rightlg} alt="rightlg" />
                        <p className="fontsize9 font-weight-bold  pt-lg-4">تم ارسال رساله للبريد الالكتروني</p>
                        <p className="fontsize11 text-muted px-lg-5">
                        تم إرسال رابط  إلى البريد الخاص بك. يرجى التحقق من صندوق الوارد الخاص بك لتدوين حسابك</p>
                        </div>
                        </div>
                        <div className="logoform col-6 d-flex align-content-end flex-wrap">
                            <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/AR/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
                            <p className="fontsize2 text-center mb-5 col-12">طلبك الخاصة بك ... طريقك</p>
                        </div>
                    </div>
                </div>
                <Footer/>

            </div>
        )
    }
}
export default ConfirmData;